import type { Repository, ValidateGitRefV2Response } from "@octopusdeploy/octopus-server-client";
import { HasRunbooksInGit } from "@octopusdeploy/octopus-server-client";
import { lastAccessedGitRef } from "~/areas/projects/context/LastAccessedGitRef";
import type { ProjectContextProps } from "~/areas/projects/context/index";
export async function loadRunbookAndGitRef(repository: Repository, spaceId: string, processId: string, projectContext: Promise<ProjectContextProps>, gitRef?: string | undefined) {
    const { state: { model: project }, } = await projectContext;
    let runbookProcess = undefined;
    let gitRefValidationResult: ValidateGitRefV2Response | undefined = undefined;
    if (HasRunbooksInGit(project.PersistenceSettings)) {
        // If we don't have the GitRef in the query parameter, fill it with the last accessed one.
        if (!gitRef) {
            gitRef = lastAccessedGitRef.get(project);
        }
        gitRefValidationResult = await repository.Projects.validateGitRef(project.SpaceId, project.Id, gitRef);
        runbookProcess = await repository.Runbooks.getRunbookProcess(project.Id, spaceId, processId, gitRefValidationResult.GitRef?.CanonicalName ?? gitRef);
    }
    else {
        runbookProcess = await repository.Runbooks.getRunbookProcess(project.Id, spaceId, processId, undefined);
    }
    return {
        process: runbookProcess,
        gitRefValidationResult,
    };
}
